module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-container",
    staticStyle: {
      "height": "calc(100% - 55px)"
    }
  }, [_c('div', {
    staticClass: "uk-flex uk-flex-left margin-top-responsive"
  }, [_c('div', {
    staticClass: "uk-padding-small",
    attrs: {
      "id": "logo"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.config.logo_url,
      "alt": "Logo"
    }
  })])]), _vm._v(" "), (_vm.loginShow === false) ? _c('div', {
    staticClass: "uk-flex uk-flex-wrap uk-flex-center padding-responsive"
  }, [_c('div', {
    staticClass: "uk-width-1-2@s"
  }, [_c('div', {
    staticClass: "uk-card uk-card-default uk-card-body"
  }, [_c('h3', {
    staticClass: "uk-card-title"
  }, [_vm._v("\n          Ustawienie nowego hasła\n        ")]), _vm._v(" "), (_vm.error_box) ? _c('div', {
    staticClass: "uk-alert-danger",
    attrs: {
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Podany numer pacjenta lub hasło jest nieprawidłowe.")])]) : _vm._e(), _vm._v(" "), (_vm.error_box_mismatch) ? _c('div', {
    staticClass: "uk-alert-danger",
    attrs: {
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Podane hasła nie są takie same.")])]) : _vm._e(), _vm._v(" "), (_vm.error_box_characters) ? _c('div', {
    staticClass: "uk-alert-danger",
    attrs: {
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Hasło powinno zawierać minimum 8 znaków, co najmniej 1 dużą litere, małą litere, cyfre oraz znak specjalny !@#$%^&*()+-={}|:<>?;.")])]) : _vm._e(), _vm._v(" "), (_vm.error_box_empty) ? _c('div', {
    staticClass: "uk-alert-danger",
    attrs: {
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Proszę wprowadzić ID pacjenta oraz hasło.")])]) : _vm._e(), _vm._v(" "), (_vm.error_terms) ? _c('div', {
    staticClass: "uk-alert-danger",
    attrs: {
      "uk-alert": ""
    }
  }, [_c('p', [_vm._v("Akceptacja informacji o przetwarzaniu jest wymagana.")])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset"
  }, [_c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.passNew),
      expression: "credentials.passNew"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "password",
      "placeholder": "Nowe hasło"
    },
    domProps: {
      "value": (_vm.credentials.passNew)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.passNew = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.passNew_2),
      expression: "credentials.passNew_2"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "password",
      "placeholder": "Powtórz nowe hasło"
    },
    domProps: {
      "value": (_vm.credentials.passNew_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.passNew_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin",
    attrs: {
      "id": "terms"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.terms),
      expression: "credentials.terms"
    }],
    staticClass: "uk-checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.credentials.terms) ? _vm._i(_vm.credentials.terms, null) > -1 : (_vm.credentials.terms)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.credentials.terms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.credentials.terms = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.credentials.terms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.credentials.terms = $$c
        }
      }
    }
  }), _vm._v("\n              Zapoznałem się z "), _c('a', {
    attrs: {
      "uk-toggle": "target: #terms-modal",
      "href": "#"
    }
  }, [_vm._v("informacją o administratorze i przetwarzaniu danych")])])]), _vm._v(" "), _c('div', {
    staticClass: "uk-flex uk-flex-right"
  }, [(Object.getOwnPropertyNames(_vm.$route.params).length === 0) ? _c('button', {
    staticClass: "uk-button uk-button-secondary uk-margin-small-left",
    attrs: {
      "id": "newpassbtn"
    },
    on: {
      "click": _vm.NewPass
    }
  }, [_vm._v("Potwierdź zmiane hasła")]) : _vm._e(), _vm._v(" "), (Object.getOwnPropertyNames(_vm.$route.params).length !== 0) ? _c('button', {
    staticClass: "uk-button uk-button-secondary uk-margin-small-left",
    attrs: {
      "id": "hashnewpassbtn"
    },
    on: {
      "click": _vm.HashNewPass
    }
  }, [_vm._v("Zatwierdź")]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), (_vm.loginShow === true) ? _c('div', {
    staticClass: "uk-card uk-card-default uk-card-body padding-responsive"
  }, [_c('div', {
    staticClass: "uk-flex uk-flex-wrap uk-flex-center"
  }, [_c('div', {
    staticClass: "uk-width-1 uk-width-1-2@m"
  }, [_c('div', {
    staticClass: "uk-card uk-card-default uk-card-body"
  }, [_c('h3', {
    staticClass: "uk-card-title"
  }, [_vm._v("\n            Logowanie do konta Pacjenta?\n          ")]), _vm._v(" "), (Object.getOwnPropertyNames(_vm.$route.params).length !== 0) ? _c('h4', [_vm._v("Id Pacjenta: " + _vm._s(_vm.$route.params.id))]) : _vm._e(), _vm._v(" "), (_vm.error_box) ? _c('div', {
    staticClass: "uk-alert-danger",
    attrs: {
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Podany numer pacjenta lub hasło jest nieprawidłowe.")])]) : _vm._e(), _vm._v(" "), (_vm.error_box_mismatch) ? _c('div', {
    staticClass: "uk-alert-danger",
    attrs: {
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Podane hasła nie są takie same.")])]) : _vm._e(), _vm._v(" "), (_vm.error_box_characters) ? _c('div', {
    staticClass: "uk-alert-danger",
    attrs: {
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Hasło powinno zawierać minimum 8 znaków, co najmniej 1 dużą litere, małą litere, cyfre oraz znak specjalny !@#$%^&*()+-={}|:<>?;.")])]) : _vm._e(), _vm._v(" "), (_vm.error_box_empty) ? _c('div', {
    staticClass: "uk-alert-danger",
    attrs: {
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Proszę wprowadzić ID pacjenta oraz hasło.")])]) : _vm._e(), _vm._v(" "), (_vm.error_terms) ? _c('div', {
    staticClass: "uk-alert-danger",
    attrs: {
      "uk-alert": ""
    }
  }, [_c('p', [_vm._v("Akceptacja informacji o przetwarzaniu jest wymagana.")])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset"
  }, [_c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.ID),
      expression: "credentials.ID"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "ID pacjenta",
      "id": "idinp"
    },
    domProps: {
      "value": (_vm.credentials.ID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.ID = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.pass),
      expression: "credentials.pass"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "password",
      "placeholder": "Hasło",
      "id": "passinp"
    },
    domProps: {
      "value": (_vm.credentials.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.pass = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin-top"
  }, [_c('div', {
    staticClass: "uk-flex uk-flex-between"
  }, [(_vm.logging_in === false) ? _c('button', {
    staticClass: "uk-button uk-button-secondary",
    attrs: {
      "id": "loginbtn"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Zaloguj")]) : _vm._e(), _vm._v(" "), (_vm.logging_in !== false) ? _c('button', {
    staticClass: "uk-button uk-button-secondary",
    attrs: {
      "id": "loginbtn-disabled",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-spinner"
  }), _vm._v(" Trwa uwierzytelnianie\n                ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-link uk-margin-left",
    attrs: {
      "type": "button",
      "uk-toggle": "target: #rememberButtons"
    }
  }, [_vm._v("Problem z logowaniem")])]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "terms-modal",
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog uk-modal-body"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Informacja dla pacjenta")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin",
    domProps: {
      "innerHTML": _vm._s(_vm.config.clinic_info.terms)
    }
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p')])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "remember-modal",
      "uk-modal": "bg-close: false"
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog uk-modal-body"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Przypomnienie hasła")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remember.ID),
      expression: "remember.ID"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "ID pacjenta",
      "id": "rememberidinp"
    },
    domProps: {
      "value": (_vm.remember.ID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remember.ID = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remember.email),
      expression: "remember.email"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "email",
      "placeholder": "Email podany przy rejestracji",
      "id": "rememberemailinp"
    },
    domProps: {
      "value": (_vm.remember.email)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.rememberAction($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remember.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "uk-flex uk-flex-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-default uk-modal-close uk-margin-small-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Anuluj")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-secondary uk-modal-close uk-margin-small-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.rememberAction
    }
  }, [_vm._v("Przypomnij")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "id-patient-reminder-modal",
      "uk-modal": "bg-close: false"
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog uk-modal-body"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Przypomnienie ID pacjenta")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('999-999-999'),
      expression: "'999-999-999'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.remember.phoneNumber),
      expression: "remember.phoneNumber"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "tel",
      "placeholder": "Numer telefonu podany przy rejestracji"
    },
    domProps: {
      "value": (_vm.remember.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remember.phoneNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('99999999999'),
      expression: "'99999999999'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.remember.pesel),
      expression: "remember.pesel"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "tel",
      "placeholder": "Numer PESEL"
    },
    domProps: {
      "value": (_vm.remember.pesel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remember.pesel = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-flex uk-flex-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-default uk-modal-close uk-margin-small-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Anuluj")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-secondary uk-modal-close uk-margin-small-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.rememberActionID
    }
  }, [_vm._v("Przypomnij")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "email-patient-reminder-modal",
      "uk-modal": "bg-close: false"
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog uk-modal-body"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Brak adresu email")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_vm._v("\n        Adres email będzie używany w celu późniejszego przypomnienia hasła do konta. Brak podania adresu email będzie wiązał się z konicznością przypomnienia hasła w klinice.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remember.email),
      expression: "remember.email"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "email",
      "placeholder": "Twój aktualny email"
    },
    domProps: {
      "value": (_vm.remember.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remember.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-flex uk-flex-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-default uk-modal-close uk-margin-small-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Anuluj")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-secondary uk-margin-small-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setEmail
    }
  }, [_vm._v("Zapisz")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "firstlogin-modal",
      "uk-modal": "bg-close: false"
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog uk-modal-body"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Pierwsze logowanie")]), _vm._v(" "), _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.ID),
      expression: "credentials.ID"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "tel",
      "placeholder": "ID pacjenta"
    },
    domProps: {
      "value": (_vm.credentials.ID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.ID = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-flex uk-flex-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-default uk-modal-close uk-margin-small-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Anuluj")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-secondary uk-modal-close uk-margin-small-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.firstLogin
    }
  }, [_vm._v("Wyślij SMS z hasłem tymczasowym")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-flex uk-flex-right uk-margin-top",
    attrs: {
      "id": "rememberButtons",
      "hidden": ""
    }
  }, [_c('button', {
    staticClass: "uk-button uk-button-default uk-button-small uk-margin-small-left",
    attrs: {
      "uk-toggle": "target: #id-patient-reminder-modal",
      "id": "rememberIDBtn"
    }
  }, [_vm._v("Przypomnij ID pacjenta")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-default uk-button-small uk-margin-small-left",
    attrs: {
      "uk-toggle": "target: #remember-modal",
      "id": "rememberbtn"
    }
  }, [_vm._v("Przypomnij hasło")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-hidden@m uk-margin-top"
  }, [_c('span', {
    staticClass: "uk-badge",
    staticStyle: {
      "width": "40px",
      "height": "40px",
      "font-size": "medium"
    }
  }, [_vm._v("lub")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-width-1 uk-width-1-2@m"
  }, [_c('div', {
    staticClass: "uk-card uk-card-body"
  }, [_c('h3', {
    staticClass: "uk-card-title"
  }, [_vm._v("\n            Pierwsze logowanie?\n          ")]), _vm._v(" "), _c('p', [_vm._v("Jeżeli jesteś naszym Pacjentem i podczas pobytu w placówce otrzymałeś sms z identyfikatorem aktywuj konto.")]), _vm._v(" "), _c('div', {
    staticClass: "uk-flex uk-flex-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-default uk-button-small uk-margin-small-left",
    attrs: {
      "uk-toggle": "target: #firstlogin-modal",
      "id": "firstLoginBtn"
    }
  }, [_vm._v("Aktywuj konto")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-visible@m uk-position-absolute",
    staticStyle: {
      "margin-top": "8em"
    }
  }, [_c('span', {
    staticClass: "uk-badge",
    staticStyle: {
      "width": "40px",
      "height": "40px",
      "font-size": "medium"
    }
  }, [_vm._v("lub")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-flex uk-flex-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-default uk-modal-close uk-margin-small-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Zamknij")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-margin"
  }, [_c('p', [_vm._v("Jeżeli nie podałeś adresu email podczas logowania, przypomnienie hasła może się odbyć tylko w klinice.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-alert-danger",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "error_empty_email",
      "uk-alert": ""
    }
  }, [_c('h3', [_vm._v("Wystąpił błąd")]), _vm._v(" "), _c('p', [_vm._v("Wprowadź poprawny adres email")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc92f412"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
// module id = 275
// module chunks = 1